var _path, _g, _mask, _g2, _mask2, _g3, _mask3, _g4, _mask4, _g5, _mask5, _g6, _mask6, _g7, _mask7, _g8, _mask8, _g9, _mask9, _g10, _mask10, _g11, _mask11, _g12, _mask12, _g13, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptystate = function SvgEmptystate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 280,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h280v280H0z",
    opacity: 0.01
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M218.486 170.916c0 46.526-37.717 84.243-84.243 84.243S50 217.442 50 170.916s37.717-84.242 84.243-84.242 84.243 37.716 84.243 84.242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "m186.034 74.843 15.037 39.954s5.584 14.491 17.948 18.366c13.373 4.191 14.41 26.238.994 28.261l-106.744 16.094c-13.417 2.023-18.926-19.35-7.383-27.298 10.672-7.347 11.735-22.841 11.735-22.841l2.704-42.873"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m182.143 168.534-14.396-40.972-29.368 5.614 4.783 43.611z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M179.952 119.319s8.112-21.752 7.498-33.82c-.613-12.067-9.137-30.086-30.284-32.163-21.148-2.077-33.014 13.94-35.965 25.657-2.949 11.717.776 34.632.776 34.632"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M156.571 59.394h-.001c-16.871-1.657-31.89 10.676-33.546 27.546l-1.445 14.71c-.636 6.471.084 13.02 2.252 19.15 4.922 13.918 14.688 19.366 24.709 20.351h.001c10.021.984 20.66-2.461 28.197-15.155 3.319-5.591 5.299-11.875 5.934-18.346l1.445-14.709c1.657-16.87-10.676-31.89-27.546-33.547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M143.37 94.832a.58.58 0 0 1-.445-.21c-.176-.212-4.362-5.11-10.474-1.085a.577.577 0 1 1-.635-.964c6.991-4.604 11.95 1.255 11.999 1.315a.576.576 0 0 1-.445.944M169.24 97.276a.58.58 0 0 1-.405-.166c-5.233-5.156-10.273-1.147-10.485-.973a.577.577 0 1 1-.73-.894c.06-.048 6.063-4.831 12.025 1.045a.577.577 0 0 1-.405.988"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M120.078 89.348c.066-3.796.386-7.426 1.124-10.355 2.949-11.717 14.816-27.734 35.963-25.657 21.148 2.077 29.671 20.097 30.286 32.163.157 3.101-.261 6.841-.971 10.687l-4.322 2.575c-25.926-14.629-33.671-28.178-33.671-28.178s-11.913 15.843-24.562 21.306z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M149.807 141.559c-3.311 0-6.546-.639-9.638-1.923a.576.576 0 1 1 .442-1.066c6.903 2.865 14.574 2.362 22.184-1.454a.578.578 0 0 1 .517 1.032c-4.527 2.271-9.084 3.411-13.505 3.411"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M165.114 103.57a2.355 2.355 0 1 1-4.685-.46 2.355 2.355 0 0 1 4.685.46M139.253 101.03a2.354 2.354 0 1 1-4.685-.459 2.354 2.354 0 0 1 4.685.459M144.936 114.576a.58.58 0 0 1-.377-.14c-.071-.063-1.764-1.548-1.804-3.379-.02-.893.345-1.699 1.083-2.396 1.729-1.631 2.525-4.87 2.534-4.903a.577.577 0 1 1 1.121.27c-.035.146-.883 3.604-2.863 5.473-.496.468-.733.968-.721 1.528.025 1.316 1.392 2.523 1.407 2.535a.577.577 0 0 1-.38 1.012M149.66 124.672c-.329 2.615-2.3 2.438-4.759 2.128-2.46-.309-4.476-.635-4.147-3.249.33-2.614 2.59-4.483 5.049-4.173s4.187 2.68 3.857 5.294M194.06 63.37c-.888 9.042-8.939 15.652-17.981 14.764s-15.654-8.938-14.765-17.981c.888-9.042 8.938-15.653 17.981-14.765 9.042.888 15.653 8.938 14.765 17.981"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M194.06 109.765c-1.997 5.36-7.134 8.393-11.474 6.777s-6.239-7.273-4.243-12.632c1.997-5.36 7.133-8.394 11.474-6.777 4.34 1.617 6.24 7.273 4.243 12.632"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M181.576 105.17a.578.578 0 0 1-.541-.779c.596-1.598 1.693-2.905 3.092-3.679 1.428-.79 2.996-.935 4.416-.406 1.668.622 2.873 2.071 3.305 3.977a.577.577 0 0 1-1.125.255c-.345-1.519-1.286-2.667-2.583-3.15-1.099-.409-2.326-.291-3.454.333-1.157.641-2.07 1.732-2.569 3.073a.58.58 0 0 1-.541.376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M181.795 111.22a.579.579 0 0 1-.132-1.139c.116-.028 2.898-.739 4.088-3.933 1.162-3.12-.602-4.889-.678-4.963a.578.578 0 0 1 .798-.833c.099.094 2.398 2.342.961 6.199-1.411 3.789-4.762 4.62-4.904 4.654a.7.7 0 0 1-.133.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.278 97.76c.35 5.708 4.38 10.106 9.003 9.823s8.087-5.14 7.738-10.85c-.35-5.708-4.381-10.106-9.004-9.823s-8.087 5.14-7.737 10.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M123.727 97.023a.576.576 0 0 1-.575-.542c-.088-1.428-.643-2.738-1.564-3.687-.897-.926-2.038-1.396-3.207-1.325-1.382.085-2.617.909-3.388 2.262a.578.578 0 0 1-1.003-.572c.969-1.697 2.543-2.733 4.32-2.842 1.514-.093 2.971.502 4.107 1.674 1.112 1.147 1.782 2.717 1.886 4.42a.577.577 0 0 1-.576.612"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M121.755 102.747a.6.6 0 0 1-.29-.078c-.126-.073-3.09-1.844-3.337-5.88-.251-4.107 2.603-5.59 2.725-5.65a.576.576 0 0 1 .52 1.03c-.102.053-2.296 1.234-2.093 4.55.208 3.401 2.663 4.892 2.768 4.953a.578.578 0 0 1-.293 1.075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M195.619 172.427c0 14.699-11.916 26.615-26.615 26.615-14.7 0-26.616-11.916-26.616-26.615 0-14.7 11.916-26.616 26.616-26.616s26.615 11.916 26.615 26.616"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m112.369 164.996 4.417 29.073 22.006 59.149 22.181-25.299s-21.243-32.729-23.864-36.967c-2.62-4.239-4.069-11.794-6.188-15.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M112.153 182.976c-2.63-8.463-2.837-15.539-3.334-19.719-3.21-4.463-5.588-8.542-6.398-10.718-.651-1.751-1.525-3.972-1.655-6.222-.091-1.583 1.6-2.032 2.44-.948.558.72 1.231 1.697 2.07 2.665.624.719 1.381 1.601 1.674 2.182 1.297 2.657 4.185 6.469 7.815 11.021 1.108 1.39 1.817 7.596 4.87 14.751 1.769 4.144 1.624 7.975 1.521 11.716"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M122.341 182.891c-3.874-7.97-5.145-14.934-6.265-18.992-3.846-3.929-6.812-7.603-7.94-9.632-.908-1.634-2.106-3.697-2.573-5.902-.329-1.551 1.275-2.249 2.269-1.305.66.628 1.472 1.493 2.447 2.323.726.617 1.607 1.375 1.984 1.905 1.682 2.432 5.112 5.766 9.386 9.719 1.305 1.206 2.941 7.235 7.037 13.849 2.372 3.83 2.806 7.639 3.268 11.353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.382 187.465c-3.464-8.157-4.379-15.177-5.291-19.286-3.641-4.12-6.415-7.94-7.439-10.024-.824-1.677-1.916-3.8-2.27-6.025-.249-1.566 1.388-2.182 2.333-1.188.627.661 1.395 1.566 2.326 2.444.693.654 1.535 1.456 1.884 2.005 1.556 2.513 4.811 6.017 8.879 10.183 1.242 1.271 4.117 9.855 6.533 15.943 1.663 4.188.122 7.21.393 10.943"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M118.431 175.767a.575.575 0 0 1-.55-.404c-1.087-3.451-1.731-6.547-2.249-9.034-.484-2.327-.866-4.165-1.318-4.732-2.274-2.851-7.73-9.824-9.27-12.979a.576.576 0 1 1 1.037-.506c1.49 3.052 6.885 9.944 9.135 12.765.624.782.991 2.547 1.546 5.216.512 2.463 1.149 5.527 2.219 8.924a.576.576 0 0 1-.55.75M123.687 174.916a.58.58 0 0 1-.536-.364c-1.685-4.248-2.411-7.455-2.891-9.576-.355-1.571-.612-2.705-1.017-3.214l-1.141-1.426c-3.049-3.811-5.458-6.821-6.643-9.25a.577.577 0 1 1 1.037-.506c1.129 2.314 3.503 5.28 6.507 9.035l1.142 1.428c.57.715.837 1.893 1.241 3.678.5 2.211 1.186 5.24 2.838 9.405a.578.578 0 0 1-.537.79M127.631 174.094a.58.58 0 0 1-.535-.359c-.755-1.849-1.378-3.81-1.927-5.539-.353-1.114-.688-2.165-1.001-3.005-.494-1.321-.769-1.795-1.841-3.169a.577.577 0 1 1 .91-.71c1.152 1.477 1.472 2.028 2.012 3.474.323.868.662 1.933 1.02 3.061.542 1.708 1.157 3.645 1.896 5.451a.578.578 0 0 1-.534.796"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M112.153 182.976c-2.63-8.463-2.837-15.539-3.334-19.719z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "m65.942 151.485 20.533 49.523a2.837 2.837 0 0 0 3.694 1.538l23.539-9.631a2.836 2.836 0 0 0 1.613-3.53L98.316 138.92a2.836 2.836 0 0 0-3.72-1.736L67.53 147.758a2.835 2.835 0 0 0-1.588 3.727"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "m70.957 153.64 15.127 37.423a2.597 2.597 0 0 0 3.38 1.434l18.216-7.353a2.596 2.596 0 0 0 1.483-3.252L96.078 143.81a2.6 2.6 0 0 0-3.412-1.571l-20.256 8.012a2.6 2.6 0 0 0-1.453 3.389M102.434 193.301a2.308 2.308 0 1 1-4.615.13 2.308 2.308 0 0 1 4.615-.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117.096 195.073c-7.462-4.251-9.902-11.259-12.408-14.792-4.856-6.848-9.838-9.581-8.106-11.847 2.865-3.75 12.569 4.435 21.38 12.456s-.866 14.183-.866 14.183"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__a",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    fillRule: "evenodd",
    d: "M191.23 157.782c13.26 22.535 23.211 77.168 23.211 115.631l-126.234 9.395s47.756-108.384 60.299-127.176",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__b",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M91.694 202.607c-.164-6.886-2.75-9.729-3.56-14.168-1.566-8.605-.192-14.666-2.902-14.63-4.485.058-5.174 13.708-5.389 26.482s11.851 2.316 11.851 2.316",
    clipRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__c",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M81.985 190.651c-2.55-5.688-7.945-12.35-8.751-14.404 0 0-3.695-14.924-4.07-16.174-.548-1.83-1.206-3.906-2.584-5.578-.97-1.177-2.442-.099-2.321 1.346.14 1.674.163 3.721.108 5.665s1.86 10.029 2.809 15.377c.323 1.824 3.06 6.285 5.599 13.776 1.47 4.337 4.07 6.884 6.584 9.403",
    clipRule: "evenodd"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__d",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M74.568 195.451c-1.198-3.719-4.807-8.814-5.389-10.957 0 0-2.076-15.283-2.314-16.571-.35-1.888-.782-4.033-1.973-5.874-.838-1.295-2.608.18-2.643 1.627-.04 1.678-.047 3.108-.31 5.026-.263 1.919.776 10.188 1.147 15.614.126 1.851 2.37 6.637 4.092 14.399.998 4.495 3.312 7.366 5.542 10.196",
    clipRule: "evenodd"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__e",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M73.392 204.318c-1.371-3.646-5.212-8.526-5.894-10.634 0 0-2.793-15.152-3.092-16.426-.438-1.865-.97-3.984-2.245-5.753-.898-1.246-2.434-.282-2.4 1.167.039 1.68-.061 3.722-.233 5.655s1.255 10.136 1.881 15.538c.178 1.537 2.273 4.632 4.173 10.063",
    clipRule: "evenodd"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__f",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M73.552 208.777c-1.371-3.646-5.212-8.526-5.894-10.635 0 0-2.793-15.151-3.091-16.425-.438-1.866-.97-3.984-2.246-5.754-.897-1.245-2.433-.281-2.4 1.168.04 1.679-.06 3.722-.232 5.655-.232 2.604.03 5.625.382 8.191.233 1.696 1.247 3.433 1.835 5.353.608 1.986 1.137 3.228 2.411 6.303 1.72 4.15 4.889 7.56 6.655 11.701",
    clipRule: "evenodd"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__g",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m64.275 201.894 3.716-22.875 22.81 21.53 32.53 62.104-38.983-2.707s-10.981-38.454-12.483-43.316-6.155-10.626-7.59-14.736",
    clipRule: "evenodd"
  }))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__h",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    fillRule: "evenodd",
    d: "M74.669 192.07a.58.58 0 0 1-.539-.37c-1.038-2.708-2.413-4.615-3.626-6.297-1.183-1.64-2.203-3.056-2.446-4.676q-.215-1.438-.424-2.872c-.807-5.516-1.57-10.726-2.83-15.282a.577.577 0 1 1 1.112-.307c1.28 4.625 2.047 9.869 2.86 15.422q.21 1.431.423 2.869c.202 1.343 1.101 2.591 2.24 4.17 1.193 1.654 2.676 3.711 3.768 6.559a.578.578 0 0 1-.538.784",
    clipRule: "evenodd"
  }))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__i",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    fillRule: "evenodd",
    d: "M69.864 195.242a.58.58 0 0 1-.508-.302c-1.11-2.058-2.201-3.598-3.077-4.835-1.128-1.593-1.943-2.745-2.131-4.008-.4-2.687-.866-5.087-1.316-7.409-.47-2.417-.912-4.701-1.243-7.105a.577.577 0 0 1 1.143-.157c.327 2.373.767 4.641 1.233 7.043.452 2.333.92 4.746 1.324 7.458.148.992.896 2.048 1.932 3.511.894 1.263 2.006 2.834 3.15 4.953a.578.578 0 0 1-.507.851",
    clipRule: "evenodd"
  }))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__j",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    fillRule: "evenodd",
    d: "M65.682 198.034a.58.58 0 0 1-.522-.332c-.426-.906-1.075-1.994-1.702-3.047-.93-1.563-1.734-2.913-1.874-3.728-.323-1.875-1.359-6.622-2.19-10.437l-.078-.355a.577.577 0 1 1 1.127-.246l.078.355c.878 4.025 1.873 8.587 2.2 10.487.104.604.93 1.991 1.729 3.334.641 1.076 1.304 2.189 1.754 3.146a.576.576 0 0 1-.522.823",
    clipRule: "evenodd"
  }))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__k",
    width: 169,
    height: 170,
    x: 50,
    y: 86,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 170.916c0 46.526 37.717 84.243 84.242 84.243 46.527 0 84.243-37.717 84.243-84.243s-37.716-84.242-84.243-84.242C87.717 86.674 50 124.39 50 170.916",
    clipRule: "evenodd"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M177.686 253.218a.577.577 0 0 1-.576-.57c-.304-25.199-2.65-44.852-6.974-58.412-2.03-6.368-4.491-11.315-7.315-14.704-2.713-3.257-5.775-5.088-9.101-5.441a.578.578 0 0 1 .122-1.148c15.149 1.611 23.822 29.913 24.422 79.691a.577.577 0 0 1-.57.584z",
    clipRule: "evenodd"
  }))), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "emptystate_svg__l",
    width: 56,
    height: 56,
    x: 55,
    y: 16,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M55.841 16.497h54.792v54.791H55.841z",
    clipRule: "evenodd"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptystate_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    fillRule: "evenodd",
    d: "M83.237 16.497c-15.106 0-27.396 12.29-27.396 27.396s12.29 27.395 27.396 27.395h20.975v-9.812a27.34 27.34 0 0 0 6.421-17.583c0-15.106-12.29-27.396-27.396-27.396",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M79.803 53.153c0-1.879 1.555-3.433 3.434-3.433s3.434 1.554 3.434 3.433c0 1.88-1.555 3.434-3.434 3.434s-3.434-1.554-3.434-3.434m6.325-15.143c0-1.265-.831-2.096-2.674-2.096-1.988 0-3.18 1.337-3.904 3.036l-4.987-2.856c1.59-3.722 5.096-5.818 9.108-5.818 4.12 0 8.24 2.53 8.24 7.228 0 5.385-5.783 7.048-5.783 9.541h-5.783c0-4.228 5.783-5.855 5.783-9.035",
    clipRule: "evenodd"
  })));
};
export default SvgEmptystate;